import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { listTeachersWaliKelas, setSelectedTeacher } from '../../features/waliKelasSlice';
import Search from '../Search';

function ModalTeacher({ onClose }) {
    const dispatch = useDispatch();
    const { listTeachers } = useSelector((state) => state.waliKelas);
    const [search, setSearch] = useState('');
    const modalRef = useRef(null);

    useEffect(() => {
        dispatch(listTeachersWaliKelas());
    }, []);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                onClose();
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [onClose]);

    const filtered = listTeachers.filter((t) =>
        t.nama.toLowerCase().includes(search.toLowerCase())
    );

    function handleSelect(teacher) {
        dispatch(setSelectedTeacher({ id: teacher.id, nama: teacher.nama }));
        onClose();
    }

    return (
        <div className='bg-modal'>
            <div className='modal-container' ref={modalRef}>
                <h1>Pilih Guru</h1>
                <Search
                    placeholder='Cari guru'
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    onKeyDown={() => {}}
                />
                <div className='wrapper-list'>
                    {filtered.length === 0
                        ? <span>Guru tidak ditemukan</span>
                        : filtered.map((item, index) => (
                            <div
                                className='container-list'
                                key={index}
                                onClick={() => handleSelect(item)}
                            >
                                <p>{item.nama}</p>
                                <p>+</p>
                            </div>
                        ))
                    }
                </div>
            </div>
        </div>
    );
}

export default ModalTeacher;
